import React from 'react'

export default function Symbol(props) {
    return (
        <div>
            <div className="bottomContainers locationContainer flexCenter">
                {props.name()}
                <p>{props.title}</p>
            </div>
        </div>
    )
}
